// extracted by mini-css-extract-plugin
export default {"backLinkBox":"backLinkBox__3pYVw","overlayBox":"overlayBox__2h9Ls","box":"box__flbDT"};